import type {LayersAnimationConfig} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';

export interface NavigationAction {
  url: string;
  openInNewTab?: boolean;
  onBeforeNavigate?: () => void;
}

export interface LayersVisualConfig {
  loadingTitle: string;
  readyTitle: string;
  animation: LayersAnimationConfig;
}

export enum AiActionVisualKind {
  SPARKLE = 'sparkle',
  LAYERS = 'layers',
}

export interface SparkleVisual {
  kind: AiActionVisualKind.SPARKLE;
}

export interface LayersVisual {
  kind: AiActionVisualKind.LAYERS;
  layers: LayersVisualConfig;
}

export type AiActionVisual = SparkleVisual | LayersVisual;

export interface AiActionLoadingModalProps {
  title: string;
  loadingText?: string;
  completedText?: string;
  navigationAction?: NavigationAction;
  ctaText?: string;
  visual?: AiActionVisual;
  loadingTexts?: string[];
}
